import MasterComponent from "../../../../../components/Forms";
import { MasterConfigs } from "../../../../../interfaces/entity";

const BankAccounts = () => {

  const accountConfig: MasterConfigs = {
    api: () => '/bank-accounts',
    title: 'Accounts',
    isActionTab: true,
    maskClosable: false,
    modalTitle: (action) => action + ' Accounts',
    getColumns: () => {
      return [
        {
          title: 'Beneficiary Name',
          dataIndex: 'beneficiaryName',
          key: 'beneficiaryName',
        },
        {
          title: 'Beneficiary Account Number',
          dataIndex: 'beneficiaryAccountNumber',
          key: 'beneficiaryAccountNumber',
        },
        {
          title: 'Bank Name and Address',
          dataIndex: 'bankNameAndAddress',
          key: 'bankNameAndAddress',
        },
        {
          title: 'Bank Type',
          dataIndex: 'bankType',
          key: 'bankType',
        },
        {
          title: 'IFSC Number',
          dataIndex: 'ifscNumber',
          key: 'ifscNumber',
        },
        {
          title: 'Created At',
          dataIndex: 'createdAt',
          key: 'createdAt',
        },
      ];
    },
    getFormColumns: () => {
      return [
        {
          label: 'Beneficiary Name',
          name: 'beneficiaryName',
          key: 'beneficiaryName',
          type: 'text',
        },
        {
          label: 'Beneficiary Account Number',
          name: 'beneficiaryAccountNumber',
          key: 'beneficiaryAccountNumber',
          type: 'number',
        },
        {
          label: 'Bank Name and Address',
          name: 'bankNameAndAddress',
          key: 'bankNameAndAddress',
          type: 'text',
        },

        {
          label: 'Bank Type',
          name: 'bankType',
          key: 'bankType',
          type: 'select',
          children: [
            { name: 'Saving', value: 'Saving' },
            { name: 'Current', value: 'Current' },
            { name: 'Salary', value: 'Salary' },
            { name: 'Other', value: 'Other' },
          ],
        },
        {
          label: 'IFSC Number',
          name: 'ifscNumber',
          key: 'ifscNumber',
          type: 'text',
        },
        {
          label: 'PAN',
          name: 'PAN',
          key: 'PAN',
          type: 'text',
        },
        {
          label: 'LUT Number',
          name: 'LUT',
          key: 'LUT',
          type: 'text',
        },
        {
          label: 'GST Number',
          name: 'GST',
          key: 'GST',
          type: 'text',
        },
        {
          label: 'CIN',
          name: 'CIN',
          key: 'CIN',
          type: 'text',
        },
        {
          label: 'State',
          name: 'state',
          key: 'state',
          type: 'text',
        },
        {
          label: 'City',
          name: 'city',
          key: 'city',
          type: 'text',
        },
        {
          label: 'Zip Code',
          name: 'zipCode',
          key: 'zipCode',
          type: 'text',
        },
        {
          label: 'Address Line 1',
          name: 'addressLine1',
          key: 'addressLine1',
          type: 'textarea',
        },
        {
          label: 'Address Line 2',
          name: 'addressLine2',
          key: 'addressLine2',
          type: 'textarea',
        },
      ];
    },
    getData: () => ({}),
    actions: [
      {
        name: 'Add',
        actionType: 'Add'
      }
    ],
  };



  return <MasterComponent config={accountConfig} />
}

export default BankAccounts;